module.exports = __webpack_public_path__ + "static/img/7.23c1332.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/soft/7.jpg
// module id = hs7u
// module chunks = 13